import { z } from 'zod';
import { SnowflakeAuthenticationType, WarehouseTypes, } from './projects';
// Zod schema for validating Snowflake SSO user warehouse credentials
// Requires refreshToken and disallows token field
export const snowflakeSsoUserCredentialsSchema = z
    .object({
    type: z.literal(WarehouseTypes.SNOWFLAKE),
    user: z.string().optional(),
    password: z.string().optional(),
    authenticationType: z.literal(SnowflakeAuthenticationType.SSO),
    refreshToken: z.string(),
})
    .strict();
//# sourceMappingURL=userWarehouseCredentials.js.map